import type { HTMLAttributes } from 'react'

import { appSelectors } from '@appStore/reducers/app'
import { linkedInProfileOpener } from 'api/linkedInProfileOpener'
import linkIconAccent from 'assets/image/icons/svg/icons/linkIconAccent.svg'
import clsx from 'clsx'
import { NavigationMenu } from 'components/molecules/navigationMenu/NavigationMenu.tsx'
import { NotificationUI } from 'features/notifications'

import './style.scss'

import { useAppSelector } from 'shared/hooks/store.ts'

import Logo from '../../atoms/Logo'
import { UserProfilePersona } from '../userProfilePersona'
import css from './Header.module.scss'
import { ImpersonatedTimer } from './ImpersonatedTimer.tsx'

export function Header({ className }: HTMLAttributes<HTMLElement>) {
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)

	return (
		<header className={clsx('header', className)}>
			<Logo />
			<div className={css.navigation}>
				<NavigationMenu />

				{isImpersonated && <ImpersonatedTimer />}

				<div
					className={
						isImpersonated
							? 'header-navigation-profile-accent'
							: 'header-navigation-profile'
					}
				>
					{isImpersonated && <LinkedLink />}

					<UserProfilePersona />
				</div>
				<NotificationUI.Notification />
			</div>
		</header>
	)
}

// ? Why not link
function LinkedLink() {
	const linkedInProfile = useAppSelector(
		state => appSelectors.persona(state)?.linkedInProfile
	)

	return (
		<img
			alt='linkIcon'
			className='image-icon-accent'
			onClick={() => {
				linkedInProfileOpener.open(linkedInProfile)
			}}
			src={linkIconAccent}
		/>
	)
}
